import React, { useEffect } from "react";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
export function PageNotFound(props) {
  console.log(props)
  const footer = (
    <div>
      {/* <Button icon="pi pi-arrow-left" label="Go Back" className="p-2 px-3 btn-primary"
        onClick={() => { props.resetError() }} /> */}
      <button className="p-0 fs-12 btn btn-primary btn-sm min-width-btn my-0 ms-0"
        onClick={() => { props.resetError() }} >Go Back</button>
    </div>
  );

  const fnDialogBtn = [
    { buttonModel: { content: 'Go Back', cssClass: 'e-flat', isPrimary: true, }, 'click': () => { props.resetError() } },

  ];

  return (
    <React.Fragment>
      {/* <Dialog className="error-popup" header="Error Occurred" footer={footer} visible="true" breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '60vw', height: "60vh" }} >
        <div className="container-fluid">
          <div className="row">            
            <div className="col-md-12">
              <div>Error Message</div>
              <div>{props.error.message}</div>
              <div >
                <div>Error Stack</div>
                <div>{props.error.stack}</div>

              </div>
            </div>
          </div>
        </div>
      </Dialog> */}

      <DialogComponent id="childtable" isModal={true}
        style={{ "--ost-table-fix-height": '360px' }}
        cssClass="ost-parameter-dialogue"
        buttons={fnDialogBtn}
        header="Error Occurred"
        width="550px"
        height="450px"
        visible={true}
      >
        <div className="container-fluid">
          <div className="row">
            {/* <div class="tac-error-code"><span>ER</span><span>RO</span><span>R</span></div> */}
            {/* <h1 className="text-uppercase fw-bold text-theme-blue">Error Occurred</h1> */}
            <div className="col-md-12">
              <div>Error Message</div>
              <div>{props.error.message}</div>
              <div >
                <div>Error Stack</div>
                <div>{props.error.stack}</div>
              </div>
            </div>
          </div>
        </div>
      </DialogComponent>
    </React.Fragment>
  )
}